import React from 'react';
import { MarkdownEditorProps } from './types';
import MDXMarkdownEditor from './editors/mdxeditor';

const MarkdownEditor = (props: MarkdownEditorProps) => {
  return <MDXMarkdownEditor {...props} />;
};

export default MarkdownEditor;
